import React from 'react';
import { Stack, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { isTimePassed, pad } from '../../../utils/helpers/secondsToHMS';
import Countdown from 'react-countdown';

const CountDown = ({ date = new Date(), clsName = '' }) => {

    const completedRenderer = () => <Typography variant='body2' className={`text-border ${clsName}`}>00h 00m 00s</Typography>;

    const renderer = ({ hours, minutes, seconds, completed }) => {
        if (completed) {
            return completedRenderer();
        } else {
            return (
                <Stack direction={'row'} spacing={1}>
                    <Typography variant='body2' className={`text-border ${clsName}`}>{pad(hours)}h</Typography>
                    <Typography variant='body2' className={`text-border ${clsName}`}>{pad(minutes)}m</Typography>
                    <Typography variant='body2' className={`text-border ${clsName}`}>{pad(seconds)}s</Typography>
                </Stack>
            );
        }
    };

    return (
        <React.Fragment>
            {!isTimePassed(date) ?
                <Countdown date={new Date(date)} renderer={renderer} />
                : completedRenderer()}

        </React.Fragment>
    );
};

CountDown.propTypes = {
    h: PropTypes.number,
    m: PropTypes.number,
    s: PropTypes.number,
    isDate: PropTypes.bool,
    clsName: PropTypes.string,
    date: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
};

export default CountDown;
